import GameLeaderboardHeader from './Header';
import GameLeaderboardContent from './Content';
import { GameLeaderboardProps } from './props';
import styles from './styles.module.scss';
import { memo } from 'react';
import { ErrorCard } from '@starsoft/common/components';

function GameLeaderboard({
  round,
  shouldShowResult = true,
  fetchNextPage,
  scoreboard,
  error,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
  refetch,
  isHeaderHidden,
  shouldShowReducedInfo,
  isTransparent,
  smallerHeight,
}: GameLeaderboardProps) {
  if (error) {
    return <ErrorCard error={error} refetch={() => refetch?.()} />;
  }

  return (
    <div
      className={`${styles.container} ${isHeaderHidden ? styles['container--header-hidden'] : ''} ${isTransparent ? styles['container--transparent'] : ''}`}
    >
      {!isHeaderHidden && (
        <GameLeaderboardHeader
          isLoading={isLoading}
          count={round?.analytics?.betsCount}
          round={round}
          shouldShowResult={shouldShowResult}
        />
      )}

      <GameLeaderboardContent
        scoreboard={scoreboard ?? []}
        isLoading={isLoading}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        shouldShowResult={shouldShowResult}
        shouldShowReducedInfo={shouldShowReducedInfo}
        smallerHeight={smallerHeight}
      />
    </div>
  );
}

export default memo(GameLeaderboard);
